<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <h1>Update Multiple Flights</h1>
                </div>
            </div>
            
            <form class="form" v-on:submit.prevent="updateBulkFlight">
                <div class="row">
                    <div class="col-md-12">
                        <div class="box">
                            <div class="row p-4">
                                <div class="col-md-2">
                                    <div>
                                        <label for="flight-number">Flight Number</label>
                                        <input id="flight-number" type="text" v-model="flight_filter.flight_number"/>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <label for="departure-time">Filter From Date</label>
                                    <dateTimePicker
                                        no-label
                                        label="Filter From Date"
                                        id="deaprture_date"
                                        format="YYYY-MM-DD"
                                        formatted="YYYY-MM-DD"
                                        button-color="#ec391e"
                                        color="#ec391e"
                                        :only-date="true"
                                        v-model="flight_filter.date_range.from"
                                        style="border: 1px solid #DFE5F9"
                                    />
                                </div>
                                <div class="col-md-2">
                                    <label for="departure-time">Filter To Date</label>
                                    <dateTimePicker
                                        no-label
                                        label="Filter To Date"
                                        id="deaprture_date"
                                        format="YYYY-MM-DD"
                                        formatted="YYYY-MM-DD"
                                        button-color="#ec391e"
                                        color="#ec391e"
                                        :only-date="true"
                                        v-model="flight_filter.date_range.to"
                                        style="border: 1px solid #DFE5F9"
                                    />
                                </div>
                                <div class="col-md-6">
                                    <div class="row">
                                        <div class="col-md-12" style="display: flex; gap: 20px;">
                                            <div v-for="week in daysOfWeek" :key="week">
                                                <label for="sunday">{{ week.charAt(0).toUpperCase() + week.slice(1) }}</label>
                                                <input 
                                                    type="checkbox"
                                                    :id="week"
                                                    :name="week"
                                                    :value="week"
                                                    v-model="flight_filter.selectedWeek"
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>        
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="box">
                            <FlightFields :showTimeForDates="true" :airlines="airlines"/>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md-12">
                        <button type="submit" class="button">Update flight details</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import FlightFields from '@/components/FlightFields.vue'
import Errors from '@/components/Errors.vue'

export default {
    name: 'FlightBulkUpdate',
    components: {
        FlightFields,
        Errors      
    },
    created() {
        this.getAirlines()
    },
    data() {
        return {
            daysOfWeek: ['monday','tuesday','wednesday','thursday','friday','saturday', 'sunday'],
            flight_filter:{
                flight_number: null,
                date_range: {
                    to: null,
                    from:null
                },
                selectedWeek:[]
            },
            flight: {
                flight_number:null,
                departure_airport_id:null,
                departure_time:null,
                arrival_airport_id:null,
                arrival_time:null,
                flight_cost:null,
                flight_price:null,
                arrival_terminal:null,
                departure_terminal:null,
                airline:null,
                stop_sell:null,
            },
            airlines:[]
        }
    },
    methods: {
        updateBulkFlight() {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'flights/update/multiple', {
                method: 'POST',
                body: JSON.stringify({
                    filter_flight_number:this.flight_filter.flight_number,
                    date_from: this.flight_filter.date_range.from,
                    date_to: this.flight_filter.date_range.to,
                    selected_days_of_week: this.flight_filter.selectedWeek,
                    flightDetails: this.flight
                }),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.$notify({
                    type: 'success',
                    title: response.message
                });
                this.resetForm()
                this.$store.dispatch('setLoadStatus')
            });
        },
        resetForm() {
            this.flight_filter = {
                flight_number: null,
                date_range: {
                    to: null,
                    from:null
                },
                selectedWeek:[]
            }
            this.flight = {
                flight_number:null,
                departure_airport_id:null,
                departure_time:null,
                arrival_airport_id:null,
                arrival_time:null,
                flight_cost:null,
                flight_price:null,
                arrival_terminal:null,
                departure_terminal:null,
                airline:null,
                stop_sell:null,
            }
        },
        getAirlines () {
            this.$store.dispatch('setLoadStatus')
            fetch(this.$api + 'airlines/', {
                headers: {
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.$store.dispatch('setLoadStatus')
                this.airlines = response.data
            })
        }
    }        
}
</script>
